export default __webpack_public_path__ + "static/media/secretary.acc7ed27.svg";